export enum HitType {
  BLOG = 'blog',
  BUNDLE = 'bundle',
  CATEGORY = 'category',
  PAGE = 'page',
  PRODUCT = 'product',
}
